import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TheUserDropdown } from '@maropost-ui/liquidsky-ui'
import { useUserStore } from '@/lib/stores'
import useUserDropdownMenu from '@/lib/composable/usermenu/userDropdownMenu'

/* --------------------------------------------------
 * Store
 * --------------------------------------------------
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'UserDropDown',
  setup(__props) {

const userStore = useUserStore()

/* --------------------------------------------------
 * Reactive Menu (AUTO-UPDATES ON ACCESS CHANGE)
 * --------------------------------------------------
 */
const userItems = useUserDropdownMenu()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TheUserDropdown), {
    items: _unref(userItems),
    username: _unref(userStore).username,
    onLogout: _unref(userStore).logout
  }, null, 8, ["items", "username", "onLogout"]))
}
}

})